import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import CustomModal from "../../../../components/Modals/CustomModal";
import { Button } from "../../../../components/Buttons";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import EventEmitter from "../../../../utils/emitter/EventEmitter";
import {
  EMITTER_ERROR,
  EMITTER_SUCCESS,
} from "../../../../utils/constants";
import { CampaignSettingsEndpoints } from "../../../../utils/constants/httpConstants";
import { deleteRequest } from "../../../../Apis/apiWrapper";
import { getErrorMessage } from "../../../../utils/helpers";
import { GREY, PRIMARY } from "../../../../utils/constants/colors";
import { fontWeight, ICON_LABELS } from "../../../../utils/constants/UI";
import { STRINGS } from "../../../Marketing/strings";

const DeleteGroupModal = ({ open, onClose, onDeleted, group }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [blockedMessage, setBlockedMessage] = useState("");

  useEffect(() => {
    if (open) setBlockedMessage("");
  }, [open]);

  const handleDelete = async () => {
    if (!group?._id) return;
    try {
      setIsDeleting(true);
      const response = await deleteRequest(
        `${CampaignSettingsEndpoints.mailboxGroupDelete}/${group._id}`,
      );
      EventEmitter.emit(
        EMITTER_SUCCESS,
        response?.data?.message || "Group deleted",
      );
      onDeleted?.(group._id);
      onClose?.();
    } catch (err) {
      const apiMessage = err?.data?.message || "";
      // 422 "Group is not empty…" → show inline so the user gets the why.
      if (err?.status === 422 || /not empty/i.test(apiMessage)) {
        setBlockedMessage(
          apiMessage ||
            "Group is not empty. Remove or move all emails before deleting.",
        );
      } else {
        EventEmitter.emit(
          EMITTER_ERROR,
          getErrorMessage(err?.data?.data?.errors || {}, apiMessage),
        );
      }
    } finally {
      setIsDeleting(false);
    }
  };

  const header = {
    heading: {
      id: "delete-group",
      label: STRINGS.DELETE_GROUP_TITLE,
    },
    alertIcon: {
      id: "delete-icon",
      label: ICON_LABELS.DELETE,
    },
  };

  const body = (
    <Box sx={{ padding: "4px 16px 16px 16px" }}>
      <TypographyInline
        size={"md"}
        color={GREY.PRIMARY}
        fontWeight={fontWeight.SEMIBOLD}
        label={group?.group_name || STRINGS.DELETE_GROUP_TITLE}
      />
      <TypographyInline
        size={"xs"}
        color={blockedMessage ? PRIMARY.W_500 : GREY.SECONDARY}
        fontWeight={fontWeight.REGULAR}
        label={blockedMessage || STRINGS.DELETE_GROUP_CONFIRM}
      />
    </Box>
  );

  const footerRight = (
    <Box sx={{ display: "flex", gap: "8px" }}>
      <Button
        label={STRINGS.CANCEL}
        size={"sm36"}
        variant={"ghost"}
        onClick={onClose}
      />
      <Button
        label={STRINGS.DELETE}
        size={"sm36"}
        variant={"primary"}
        onClick={handleDelete}
        isLoading={isDeleting}
        disabled={Boolean(blockedMessage)}
      />
    </Box>
  );

  return (
    <CustomModal
      open={open}
      close={onClose}
      header={header}
      children={body}
      footer={{ left: <div />, right: footerRight }}
      variant={"alert"}
      remove_padding
    />
  );
};

export default DeleteGroupModal;
